import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';

import RMSStatementExamZHCN from './zh-CN';
import RMSStatementExamENUS from './en-Us';
import RMSStatementExamURPK from './ur-PK';
import RMSStatementExamARAE from './ar-AE';
import RMSStatementExamPLL from './pl-PL';
import RMSStatementExamDEDE from './de-DE';
import RMSStatementExamRURU from './ru-RU';
import RMSStatementExamZHTW from './zh-TW';
import RMSStatementExamZHHK from './zh-HK';
import RMSStatementExamFRFR from './fr-FR';
import RMSStatementExamKOKR from './ko-KR';
import RMSStatementExamCSCH from './cs-CZ';
import RMSStatementExamRORO from './ro-RO';
import RMSStatementExamMSMY from './ms-MY';
import RMSStatementExamJAPJ from './ja-JP';
import RMSStatementExamTRTR from './tr-TR';
import RMSStatementExamTHTH from './th-TH';
import RMSStatementExamITIT from './it-IT';
import RMSStatementExamIDID from './id-ID';
import RMSStatementExamVINVN from './vi-VN';
import RMSStatementExamESLA from './es-LA';
import RMSStatementExamESES from './es-ES';

const RMSStatementExamRoutes: React.FC = () => {
  return (
    <Routes>
      <Route path="zh-CN" element={<RMSStatementExamZHCN />} />
      <Route path="en-US" element={<RMSStatementExamENUS />} />
      <Route path="ur-PK" element={<RMSStatementExamURPK />} />
      <Route path="ar-AE" element={<RMSStatementExamARAE />} />
      <Route path="pl-PL" element={<RMSStatementExamPLL />} />
      <Route path="de-DE" element={<RMSStatementExamDEDE />} />
      <Route path="ru-RU" element={<RMSStatementExamRURU />} />
      <Route path="zh-TW" element={<RMSStatementExamZHTW />} />
      <Route path="zh-HK" element={<RMSStatementExamZHHK />} />
      <Route path="fr-FR" element={<RMSStatementExamFRFR />} />
      <Route path="ko-KR" element={<RMSStatementExamKOKR />} />
      <Route path="cs-CZ" element={<RMSStatementExamCSCH />} />
      <Route path="ro-RO" element={<RMSStatementExamRORO />} />
      <Route path="ms-MY" element={<RMSStatementExamMSMY />} />
      <Route path="ja-JP" element={<RMSStatementExamJAPJ />} />
      <Route path="tr-TR" element={<RMSStatementExamTRTR />} />
      <Route path="th-TH" element={<RMSStatementExamTHTH />} />
      <Route path="it-IT" element={<RMSStatementExamITIT />} />
      <Route path="id-ID" element={<RMSStatementExamIDID />} />
      <Route path="vi-VN" element={<RMSStatementExamVINVN />} />
      <Route path="es-419" element={<RMSStatementExamESLA />} />
      <Route path="es-ES" element={<RMSStatementExamESES />} />

      {/* 兜底：不存在的语言跳转英语 */}
      <Route path="*" element={<Navigate to="en-US" replace />} />
    </Routes>
  );
};

export default RMSStatementExamRoutes;


